import { type BaseItem } from './common.js';

// duplicated from /backend/primary/src/models/note
export enum Reason {
  UnknownTemplate = 'Unknown Template',
  MissingAudio = 'Missing Audio',
  AudioQuality = 'Audio Quality',
  UnknownWord = 'Unknown Word',
  ExportUnavailable = 'Export Unavailable',
  ExportDisabled = 'Export Disabled',
  ReviewRequiredBySettings = 'Review Required by Settings',
  NoNoteContent = 'No Note Content',
  PotentialTemplateConflict = 'Potential Template Conflict',
  DiagnosisRepeatedInContent = 'Diagnosis Repeated in Content',
  UnsupportedFieldsInHeaderFooter = 'Unsupported Fields in Header/Footer',
  ForbiddenContent = 'Forbidden Content',
  MissingEhrValues = 'Missing EHR Values',
  MissingCarryValues = 'Missing Carry Values',
  AsterisksInTemplate = 'Asterisks in Template',
  PatientMismatch = 'Patient Mismatch',
  Other = 'Other',
}

// User-selectable (non-automatic) reasons
export const ContentNeedsReviewReasonValues = [
  Reason.UnknownWord,
  Reason.UnknownTemplate,
  Reason.MissingAudio,
  Reason.AudioQuality,
  Reason.AsterisksInTemplate,
  Reason.PatientMismatch,
  Reason.Other,
];

export enum Kind {
  Notable = 'NOTABLE',
  SignOff = 'SIGN_OFF', // deprecated
  EHR = 'EHR',
}

export interface Note extends BaseItem {
  encounterId: string;
  contentNeedsReviewReasons: Reason[];
  contentNeedsReviewComment: string;
  kind: Kind;
  ehrIsAuthorNotable?: boolean;
  ehrAuthor?: string;
  ehrIsSigned?: boolean;
  ehrUpdated?: Date;
}

// Straight up copy from fields.ts on primary
export const episodeOBFieldNames: string[] = ['GPTAL Score', 'Gestational Age (Weeks)'];

// Validation Fields - TODO: move to separate file
export interface NoteValidation {
  // section level validations
  hpi?: ValidationValue;
  pe?: ValidationValue;
  ros?: ValidationValue;
  ap?: ValidationValue;
  patientInstructions?: ValidationValue;
  discussionNotes?: ValidationValue;
  procedureDocumentation?: ValidationValue;
  interpretations?: InterpretationsValidation;
  chiefComplaint?: ValidationValue;
  // note level validation
  numNotes?: ValidationValue;
  [key: string]: ValidationValue | InterpretationsValidation | undefined;
}

export interface OrdersValidation {
  valid: boolean;
  orders: Record<string, OrderValidation>;
}

export interface InterpretationsValidation {
  valid: boolean;
  invalidInterpretations?: InterpretationValidation[];
}

// union of various kinds of validation value shapes - hack to keep compile
export type Validation = Partial<ValidationValue & InterpretationsValidation>;

export interface ValidationValue {
  valid: boolean;
  actual: string;
  expected: string;
  reason?: string;
  msg?: string;
}

export interface InterpretationValidation {
  description?: string;
  actual: string;
  expected: string;
  [key: string]: string | undefined;
}

export interface ProblemsValidation {
  name: ValidationValue;
  isNewProblem?: boolean;
  icd10s?: ValidationValue[];
}

export interface OrderValidation {
  name: ValidationValue;
  kind: ValidationValue;
  problem: ValidationValue;
}

export interface BillingValidation {
  emCode: ValidationValue;
  [key: string]: ValidationValue;
}

export interface AggregatedValidations {
  noteValidation: NoteValidation;
  billingValidation: BillingValidation;
  orderValidation: OrdersValidation;
  problemsValidation: ProblemsValidation[];
  [key: string]: NoteValidation | BillingValidation | OrdersValidation | ProblemsValidation[];
}

export interface FindAllOptions {
  limit?: number;
  providerUserId?: string;
  assignedAnalystUserId?: string;
  encounterStartTimeBefore?: string;
  encounterStartTimeAfter?: string;
  completed?: boolean;
  includeDeleted?: boolean;
}
